import { type FC, type ReactNode } from 'react';
import { useAppSelector } from '@/features';
import { Link } from '@tanstack/react-router';
import { getLogoSelector, getThemeSelector } from 'features/Settings';

import * as logoUrl from '../../assets/images/enerlink-bajada-negativo.png';

const SignInCard: FC<{ children?: ReactNode }> = ({ children }) => {
  const theme = useAppSelector((state) => getThemeSelector(state));
  const logo = useAppSelector((state) => getLogoSelector(state));

  return (
    <div className="app-login-main-content d-flex flex-column">
      <div
        className="app-logo-content d-flex align-items-center justify-content-center p-0"
        style={{ background: theme.background }}
      >
        <Link className="logo-lg" to="/" title="EVX">
          <img src={logoUrl.default} alt="EVX" title="EVX" hidden={!!logo} />
          <img src={logo} alt="EVX" title="EVX" hidden={!logo} />
        </Link>
      </div>
      <div className="app-login-content">{children}</div>
    </div>
  );
};

export default SignInCard;
